import React from 'react'
import PropTypes from 'prop-types'
import CellLink from './CellLink'
import { ChevronRightIcon } from '@heroicons/react/outline'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'

const CellAssetName = ({ assetName, to, isLink = false, isTitle = false }) => {
    const compressedAssetName =
        assetName?.length > 30 ? assetName?.slice(0, 30) + '...' : assetName
    const { push } = useHistory()

    return (
        <>
            {isLink ? (
                <div className="w-full h-full transition-all flex flex-row items-center justify-between border-0">
                    <CellLink text={assetName} to={to} needRelative={false} />
                    <ChevronRightIcon
                        onClick={() => push(to)}
                        className="w-6 h-6 text-black90 lg:hidden block"
                    />
                </div>
            ) : (
                <p
                    className={clsx(
                        'text-textDarkerGray font-normal text-base truncate max-w-full',
                        isTitle ? 'text-left' : 'text-right lg:text-left',
                    )}
                >
                    {compressedAssetName}
                </p>
            )}
        </>
    )
}

CellAssetName.propTypes = {
    assetName: PropTypes.string,
    isLink: PropTypes.bool,
    isTitle: PropTypes.bool,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
}

export default CellAssetName
